import { Hand, Gem } from "lucide-react";

export default function HandcraftedManifesto() {
  return (
    <section data-testid="handcrafted-manifesto" className="relative bg-cream py-20 md:py-28 overflow-hidden">
      {/* Top gold hairline */}
      <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-gold/70 to-transparent" />
      <div className="absolute bottom-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-gold/70 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-[1fr_auto] gap-12 lg:gap-20 items-start">
          {/* Left: huge headline */}
          <div className="relative">
            <div className="overline text-gold mb-5">
              <span className="gold-line" />Unsere Philosophie
            </div>

            <h2 className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-[88px] leading-[0.95] tracking-tight text-ink">
              100<span className="text-gold">%</span> Handarbeit.
              <br />
              <span className="italic">Ein Unikat.</span> Nur einmal auf der Welt.
            </h2>

            <p className="mt-8 max-w-2xl text-ink/75 text-lg md:text-xl font-light leading-relaxed">
              Jedes unserer Kleider wird vollständig von Hand gefertigt – Stich für Stich,
              Detail für Detail. Du wirst <strong className="text-ink font-medium">niemandem auf deiner Feier
              im gleichen Kleid</strong> begegnen, denn jedes Stück existiert genau einmal.
            </p>

            <div className="mt-8 inline-flex flex-wrap items-center gap-x-6 gap-y-2 text-xs uppercase tracking-[0.28em] text-ink/70">
              <span className="inline-flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-gold rounded-full" />
                Handgefertigt
              </span>
              <span className="inline-flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-gold rounded-full" />
                Einzelstück
              </span>
              <span className="inline-flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-gold rounded-full" />
                Limitierte Kollektion
              </span>
            </div>
          </div>

          {/* Right: stacked accent cards */}
          <div className="flex lg:flex-col gap-4 lg:w-72">
            <AccentCard
              icon={<Hand size={20} className="text-gold" />}
              eyebrow="Stich für Stich"
              title="Von Hand gefertigt"
              copy="Keine Massenproduktion. Jede Naht, jedes Detail – sorgfältig per Hand gearbeitet."
            />
            <AccentCard
              icon={<Gem size={20} className="text-gold" />}
              eyebrow="Limitiert"
              title="Nur 1× auf der Welt"
              copy="Jedes Kleid ist ein Original. Wenn es weg ist, ist es weg."
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function AccentCard({ icon, eyebrow, title, copy }) {
  return (
    <div className="flex-1 p-6 bg-white border border-[#E5E0D8]">
      <div className="flex items-center gap-2">
        {icon}
        <span className="overline text-gold">{eyebrow}</span>
      </div>
      <h3 className="font-display text-2xl mt-3">{title}</h3>
      <p className="mt-2 text-sm text-ink/65 leading-relaxed">{copy}</p>
    </div>
  );
}
